module.exports = __webpack_public_path__ + "02dc1c82080c1139e4e9a7ed2992ee47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/fonts/Interstate-Regular.svg
// module id = 969
// module chunks = 0